import { render } from "./StructureNode.vue?vue&type=template&id=b13c9878&scoped=true"
import script from "./StructureNode.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureNode.vue?vue&type=script&setup=true&lang=js"

import "./StyleStructure.scss?vue&type=style&index=0&id=b13c9878&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13c9878"],['__file',"src/pages/scada/structure/StructureNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b13c9878"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b13c9878', __exports__)) {
    console.log('reload')
    api.reload('b13c9878', __exports__)
  }
  
  module.hot.accept("./StructureNode.vue?vue&type=template&id=b13c9878&scoped=true", () => {
    console.log('re-render')
    api.rerender('b13c9878', render)
  })

}


export default __exports__